module.exports = __webpack_public_path__ + "static/img/he7.164e951.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/he7.png
// module id = QBlC
// module chunks = 1